<template>
  <div>
    <el-row :gutter="20">
      <el-col :sm="{ span: 8, offset: 8 }" :offset="0">
        <el-card style="margin-top: 150px; min-height: 350px" shadow="never" :body-style="{ padding: '20px' }">
          <div slot="header">
            <span>Acceso restringido</span>
          </div>
          <el-form :label-position="'top'" style="padding: 0px 30px" :model="login" ref="login">
            <el-form-item label="Usuario" prop="user" :rules="[
              {
                required: true,
                message: 'campo obligatorio',
                trigger: 'blur',
              },
            ]">
              <el-input v-model="login.user" @keypress.native.enter="submitForm('login')" />
            </el-form-item>
            <el-form-item label="Contraseña" prop="pass" :rules="[
              {
                required: true,
                message: 'campo obligatorio',
                trigger: 'blur',
              },
            ]">
              <el-input v-model="login.pass" show-password @keypress.native.enter="submitForm('login')" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="procesando" @click="submitForm('login')" class="btn-block">Ingresar
              </el-button>
            </el-form-item>
          </el-form>

          <!-- <div v-if="!numero">
            <p>Ingrese un número de teléfono autorizado</p>
            <MazPhoneNumberInput
              v-model="phoneNumber"
              @update="checkNumber"
              :default-country-code="'AR'"
              :preferred-countries="['AR', 'AR']"
              :translations="{
                countrySelectorLabel: 'Cod. país',
                countrySelectorError: 'Seleccione un país',
                phoneNumberLabel: 'Número de teléfono',
                example: 'ejemplo :',
              }"
            />
          </div>
          <div class="otpcontent" v-if="numero">
            <h5>Ingrese el código de verificación recibido en {{ numero }}</h5>
            <otp-input
             v-loading.fullscreen.lock="fullscreenLoading"
              ref="otpInput"
              input-classes="otp-input"
              separator="-"
              :num-inputs="4"
              :should-auto-focus="true"
              :is-input-num="true"
              @on-change="handleOnChange"
              @on-complete="handleOnComplete"
            />
            <h2 style="margin:20px auto">

             <el-checkbox v-model="recordar">Confiar en este navegador</el-checkbox> 
            </h2>
            <el-button
              type="info"
              :loading="enviando"
              :disabled="counting"
              size="default"
              style="margin-top: 10px; float: right"
              @click="enviarCodigo"
            >
              <span v-if="!counting">Renviar código</span>
              <vue-countdown
                v-if="counting"
                :time="60000"
                @end="onCountdownEnd"
                v-slot="{ totalSeconds }"
                >Renviar código en {{ totalSeconds }} segundos</vue-countdown
              >
            </el-button>
          </div> -->
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { HTTP, TTO } from "@/axios";
// import OtpInput from "@bachdgvn/vue-otp-input";
// import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  name: "LoginView",
  components: {
    // OtpInput,
    // VueCountdown: VueCountdown,
  },
  data() {
    return {
      externo: '',
      liquidaciones: ['juan.alderete', 'vardiles', 'imendoza', 'florencia.toneguzzo', 'rluccioni', 'DTADEI', 'dtadei', 'LFOSCO', 'lfosco', 'FRUTH', 'fruth'],
      isAdmin: ['juan.alderete', 'vardiles', 'rluccioni'],
      v2: ['juan.alderete', 'mariana.zorrilla'],
      dm: ['dmtest'],
      liquidaManual: ['juan.alderete', 'imendoza'],
      procesando: false,
      login: {
        user: window.localStorage.getItem("vUser"),
        pass: window.localStorage.getItem("vPass"),
      },
      enviando: false,
      numero: "",
      code: "",
      counting: true,
      fullscreenLoading: false,
      phoneNumber: null,
      initPhoneNumberExample: "",
      results: null,
      recordar: 0,
    };
  },
  created() {
    // console.log(window.location.hostname);
    // console.log(document.domain);

    // setTimeout(() => {
    //   this.getTokenData();
    // }, 500);
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.procesando = true;
          HTTP.post("/tto/login", this.login)
            .then((res) => {
              // console.log("login externo", res);
              this.procesando = false;
              if (res.data) {
                window.sessionStorage.setItem("token", res.data.jwt);
                window.sessionStorage.setItem("operador", res.data.operador);
                window.sessionStorage.setItem("permisos", res.data.permisos);
                window.sessionStorage.setItem("numero", res.data.operador);
                window.sessionStorage.setItem("datos", JSON.stringify(res.data));
                window.sessionStorage.setItem("vUser", this.login.user);
                window.sessionStorage.setItem("vPass", this.login.pass);

                if (this.liquidaciones.includes(this.login.user)) {
                  window.sessionStorage.setItem("usuarioInterno", JSON.stringify(this.liquidaciones));
                  if (this.isAdmin.includes(this.login.user)) {
                    window.sessionStorage.setItem("isAdmin", 1);

                  }
                  else {
                    window.sessionStorage.setItem("isAdmin", 0);
                  }

                  if (this.liquidaManual.includes(this.login.user)) {
                    window.sessionStorage.setItem("liquidaManual", 1);

                  }
                  else {
                    window.sessionStorage.setItem("liquidaManual", 0);
                  }
                  this.$router.push({ name: "ttoliq", query: { token: res.data.jwt } });
                }
                else {
                  if (this.dm.includes(this.login.user)) {
                    window.sessionStorage.setItem("dm", 1);
                    this.$router.push({ name: "dm-dashboard", query: { token: res.data.jwt } });
                  }
                  else if (this.v2.includes(this.login.user)) {
                    window.sessionStorage.setItem("v2", 1);
                    this.$router.push({ name: "bot-dashboard", query: { token: res.data.jwt } });
                  }
                  else {
                    this.$router.push({ name: "manual" });
                    // window.sessionStorage.setItem("tebot", 1);
                    // this.$router.push({ name: "te-dashboard", query: { token: res.data.jwt } });

                  }
                  // this.$router.push({ name: "panel" });

                }
              }
            })
            .catch((error) => {
              this.procesando = false;
              this.error = error;
              this.$alert("Error al iniciar Session " + error);
            });
        } else {
          // console.log("error submit!!");
          this.procesando = false;
          return false;
        }
      });
    },
    checkNumber($event) {
      // results = $event
      this.result = $event;
      console.log($event);
      if ($event.isValid) {
        this.numero = $event.e164;
        this.enviarCodigo();
      } else {
        this.numero = "";
      }
    },
    getTokenData() {
      let _token = this.$route.query.token;
      window.sessionStorage.setItem("token", _token);

      if (this.$route.query.token) {
        HTTP.get(TTO + "/scValidarToken", {
          headers: {
            Authorization: `Bearer ${_token}`,
          },
        })
          .then((res) => {

            if (res.data) {
              console.log(res.data);
            }
            else {
              this.$router.push({ name: "login" });
            }

          })
          .catch(() => {

            this.$router.push({ name: "login" });

          });
      } else {
        this.$router.push({ name: "login" });
      }
    },
    handleOnComplete(value) {
      console.log("OTP completed: ", value);
      console.log("OTP code: ", this.code);
      // if(this.code == value)
      // {
      this.fullscreenLoading = true;
      HTTP.post("/verificarCodigo", {
        code: value,
        numero: this.numero.substring(1),
        recordar: this.recordar,
      })
        .then((res) => {
          if (res.data) {
            if (this.recordar) {
              window.localStorage.setItem("numero", this.numero.substring(1));
            }
            window.sessionStorage.setItem("numero", this.numero.substring(1));
            window.sessionStorage.setItem("datos", JSON.stringify(res.data.row));
            this.fullscreenLoading = false;
            this.$router.push({ name: "manual" });
          } else {
            this.$alert("No se pudo verificar el código, reintente");
          }
        })
        .catch(() => {
          this.$alert("No se pudo verificar el código, reintente");
        });
      // }
      // else{
      //   this.$alert('El código ingresa no es correcto, solicite uno nuevo', {type:'error'})
      // }
    },
    handleOnChange(value) {
      console.log("OTP changed: ", value);
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
    },
    startCountdown: function () {
      this.counting = true;
    },
    onCountdownEnd: function () {
      this.counting = false;
    },
  },
};
</script>

<style lang="scss">
.otpcontent {
  margin: 20px auto;
  width: 500px;
  text-align: center;
  align-items: center;
  align-content: stretch;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
}

.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;

  &.error {
    border: 1px solid red !important;
  }
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
